import { Skeleton } from '@/components/ui/skeleton';
import { SimpleGrid, VStack } from '@chakra-ui/react';

const LoaderSkeleton = () => {
  return (
    <SimpleGrid mt={4} w={'full'} columns={{ base: 1, md: 2 }} gap={4}>
      <VStack gap={4} alignItems='stretch'>
        <Skeleton w={'full'} h={'157px'} rounded='2xl' />
        <Skeleton w={'full'} h={'157px'} rounded='2xl' />
        <Skeleton w={'full'} h={'157px'} rounded='2xl' />
        <Skeleton w={'full'} h={'157px'} rounded='2xl' />
      </VStack>
      <Skeleton w='full' h='full' rounded='2xl' />
    </SimpleGrid>
  );
};

export default LoaderSkeleton;
